import template from "./edit-report-number.html";
import "./edit-report-number.less";

export function controller() {
	const ctrl = this;

	ctrl.handleClose = handleClose;
	ctrl.handleSave = handleSave;

	ctrl.$onInit = () => {
		ctrl.number = ctrl.resolve.number;
	};

	function handleSave() {
		ctrl.modalInstance.close(ctrl.number);
	}

	function handleClose() {
		ctrl.modalInstance.dismiss();
	}
}

export default angular.module("vesl.components.edit-report-number-modal", [])
	.component("editReportNumberModal", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	})
	.name;
